/**
 * Filters the music tree as the search box changes. Matching tracks stay
 * visible; categories hide when all their tracks are filtered out, and every
 * surviving category is expanded so matches are immediately visible.
 */
export function musiclist_filter(_event: Event) {
  const root = document.getElementById("client_musiclist");
  if (!root) return;
  const searchname = (
    document.getElementById("client_musicsearch") as HTMLInputElement
  ).value
    .toLowerCase()
    .trim();

  const tracks = root.querySelectorAll<HTMLElement>(".music-track");
  tracks.forEach((track) => {
    const name = (track.textContent || "").toLowerCase();
    track.style.display =
      !searchname || name.indexOf(searchname) !== -1 ? "" : "none";
  });

  const headers = root.querySelectorAll<HTMLElement>(".music-category");
  headers.forEach((header) => {
    const trackBox = header.nextElementSibling as HTMLElement | null;
    if (!trackBox || !trackBox.classList.contains("music-tracks")) return;
    const anyVisible = Array.from(
      trackBox.querySelectorAll<HTMLElement>(".music-track"),
    ).some((t) => t.style.display !== "none");
    header.style.display = anyVisible ? "" : "none";
    if (searchname) {
      trackBox.classList.remove("collapsed");
      const caret = header.querySelector(".music-caret");
      if (caret) caret.textContent = "\u25BE";
    }
  });
}
window.musiclist_filter = musiclist_filter;
